module.exports = __webpack_public_path__ + "img/9791189015428.9e6b6ead.jpg";